import {HttpClient} from '@angular/common/http';
import {TranslateLoader} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {BaseDataService} from '../data-repositories/base-data.service';
import {JsonHolder} from '../models/json-holder';
import {BrowserStorageService} from './browser-storage.service';

export class DbTranslateLoader implements TranslateLoader {
  constructor(private client: HttpClient, private storageService: BrowserStorageService) {
  }

  getTranslation(lang: string): Observable<any> { 
    return this.client.get<JsonHolder>(BaseDataService.getApiUrl() + 'data/getlanguage?code=' + lang)
      .pipe(map((response => {
        if (this.storageService.getLocal('lang') !== response.languageCode) {
          this.storageService.setLocal('lang', response.languageCode);
        }

        const translate = JSON.parse(response.json);

        return translate;
      })));
  }
}
